import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import FormControl from "@mui/material/FormControl";
import {getJobTypeByValue} from "../Jobs/JobCard";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import JobSummaryCard from "../Jobs/JobSummaryCard";
import React from "react";
import "../CV/CV.css"
import { Editor } from 'react-draft-wysiwyg';

function ApplicationInformation({job, jobResponsibilities}) {
    return(
        <Grid container direction={"row"} padding={2} spacing={2}>
            <Grid item xs={12} sm={12} md={8} lg={8}>
                <Grid container direction={"column"} padding={2} spacing={2}>
                    {/* -- Job Description Container -- */}
                    <Box>
                        <Grid item xs={12}>
                            <Paper elevation={2} className={"application-paper-headers"}>
                                <h2>Job Description</h2>
                            </Paper>

                            <div
                                className={"application-paper-body"}>{job.jobDetails.description || ""}</div>
                        </Grid>
                    </Box>

                    {/* -- Job Roles and Responsibilities Container -- */}
                    <Box>
                        <Grid item xs={12}>
                            <Paper elevation={2} className={"application-paper-headers"}>
                                <h2>What roles and responsibilities will you have</h2>
                            </Paper>

                            <FormControl className={"application-form-control"}>
                                <Box
                                    sx={{
                                        borderRadius: '8px',
                                        '&:hover': {
                                            borderColor: '#FF6600',
                                        },
                                        "& .Mui-focused": {
                                            borderColor: "#FF6600",
                                        },
                                    }}
                                    data-testid="wysiwyg-editor"
                                >
                                    <Editor
                                        readOnly={true}
                                        editorState={jobResponsibilities}
                                        toolbarClassName="toolbarClassName"
                                        wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName"
                                        toolbarHidden={true}
                                        toolbar={{
                                            options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link'],
                                        }}
                                    />
                                </Box>
                            </FormControl>
                        </Grid>
                    </Box>

                    {/* -- Projects -- */}
                    <Box hidden={true}>
                        <Grid item xs={12}>
                            <Paper elevation={2} className={"application-paper-headers"}>
                                <h2>What type of projects will you work on?</h2>
                            </Paper>

                            <div
                                className={"application-paper-body"}>{getJobTypeByValue(job.jobDetails.jobType) || ""}</div>
                        </Grid>
                    </Box>

                    {/* -- Skills and Experience -- */}
                    <Box hidden={true}>
                        <Grid item xs={12}>
                            <Paper elevation={2} className={"application-paper-headers"}>
                                <h2>What experience and skills are we looking for in you?</h2>
                            </Paper>

                            {
                                job.jobDetails.skills && job.jobDetails.skills.length > 0 ? job.jobDetails.skills.map((skill, index) => (
                                    <div key={index}
                                         className={"application-paper-body"}>- {skill.skill} ({skill.years} years)</div>
                                )) : ""
                            }
                        </Grid>
                    </Box>

                    {/* -- Other -- */}
                    <Box hidden={true}>
                        <Grid item xs={12}>
                            <Paper elevation={2} className={"application-paper-headers"}>
                                <h2>What other stuff do we need</h2>
                            </Paper>

                            <div
                                className={"application-paper-body"}>{job.jobDetails.description || ""}</div>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={4} lg={4}>
                <Grid container direction={"column"} padding={2} spacing={2}>
                    <Card className="application-card-container">
                        <CardContent>
                            <JobSummaryCard job={job.jobDetails} applicationState={true} hashedCode={null}/>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ApplicationInformation;